import { Url, sanitizeHref } from '@wix/da-url';
import { cleanLinkSrc } from '../../../components/utils/browser';

export const Viewer = ({ node, children }) => {
  let hashtag = node.attrs['data-hashtag'] ?? '';
  if (typeof hashtag !== 'string') {
    if (
      hashtag['data-hashtag'] &&
      typeof hashtag['data-hashtag'] === 'string'
    ) {
      hashtag = hashtag['data-hashtag'];
    } else {
      return <></>;
    }
  }
  const href = cleanLinkSrc(Url.tagsPageLink(hashtag));
  return (
    <a href={sanitizeHref(href)} target="_blank" rel="noreferrer noopener" {...node.attrs}>
      #{hashtag}
    </a>
  );
};

export default Viewer;
